var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-20px py-md-40px",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text pt-0"
  }, [_c('span', [_vm._v("유의사항")])]), _c('v-card-text', [_c('ul', {
    staticClass: "disc-list"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })];
  })], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }